import React from "react";
import {
  Factory,
  Building2,
  Home as HomeIcon,
  GraduationCap,
  Hotel,
  Wrench,
} from "lucide-react";

const SECTORS = [
  {
    icon: Factory,
    title: "Industrial",
    desc: "Factories, warehouses, manufacturing facilities with structural precision and cost-optimised delivery.",
    img: "https://images.unsplash.com/photo-1772306814076-ff65f53ac438?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwY29uc3RydWN0aW9uJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc3ODk3MDQ0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Building2,
    title: "Commercial",
    desc: "Office towers, retail developments, mixed-use projects — engineered to perform and endure.",
    img: "https://images.unsplash.com/photo-1762337009787-bad651efb880?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc3Nzg5NzA0NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: HomeIcon,
    title: "Residential",
    desc: "Villas, apartments and luxury residences crafted with considered detail and uncompromising quality.",
    img: "https://images.unsplash.com/photo-1761499102697-17f54b78fba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMHJlc2lkZW50aWFsJTIwZGVzaWdufGVufDB8fHx8MTc3Nzg5NzA0NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: GraduationCap,
    title: "Institutional",
    desc: "Educational and civic structures balancing function, compliance and community-scale durability.",
    img: "https://images.unsplash.com/photo-1562774053-701939374585?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    icon: Hotel,
    title: "Hospitality",
    desc: "Hotels and leisure projects where material intelligence meets experiential design.",
    img: "https://images.unsplash.com/photo-1765439178218-e54dcbb64bcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc3Nzg5NzA0NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Wrench,
    title: "Annual Maintenance",
    desc: "Long-term facility maintenance programs that protect asset value and uptime.",
    img: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="text-[11px] uppercase tracking-[0.4em] text-[#D4AF37] mb-5">
            What we do
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
            Six capabilities.
            <br />
            <span className="italic text-[#D4AF37]">One integrated system.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
          {SECTORS.map((s) => (
            <div
              key={s.title}
              className="group bg-[#0A0A0A] hover:bg-[#141414] transition-all duration-500 relative overflow-hidden"
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
              </div>
              <div className="p-8">
                <div className="flex items-start justify-between mb-4">
                  <s.icon
                    size={28}
                    strokeWidth={1.3}
                    className="text-[#D4AF37]"
                  />
                  <span className="text-xs text-[#737373] font-serif italic">
                    0{SECTORS.indexOf(s) + 1}
                  </span>
                </div>
                <h3 className="font-serif text-2xl text-white mb-3">{s.title}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
